import React from 'react';
import { Image } from 'react-konva';
const pipeRiserImgSrc = require('../../../../media/pipes/PipeAccessories/pipe-riser.png');

/* instantiate the image */
const image = new window.Image();
image.src = pipeRiserImgSrc;

export default class PipeRiserComponent extends React.Component {
  render() {
      return (
        <Image
          image={image}
          x={this.props.x}
          y={this.props.y}
          width={this.props.diameter}
          height={this.props.diameter}
          rotation={this.props.rotation}
        />
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/PipeAccesories/pipe-riser.component.js